export default __webpack_public_path__ + "static/sam-45be8662f15f02063d2567af89da3285.jpg";